import styled from "../styled";

const UnreadIndicator = styled.div`
  width: 12px;
  height: 12px;

  background: ${p => p.theme.color.purple60};
  color: ${p => p.theme.color.white};
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: ${p => p.theme.spacing.l};
`;

export default UnreadIndicator;
